import { logout, getUsajConfig, getUserObject } from './sessionmain';
import { getCurrentTime } from '../utilities';

const warnTime = 480000; // 8 min
const heartbeatInterval = 1000;
let sessionTimerModal: HTMLDialogElement | null;
let sessionStart = 0;
let heartbeatTimer: ReturnType<typeof setInterval> | null = null;
let timeOut = 1200000; // default to 20 min
let warnAfter = timeOut - warnTime;
let gaveWarning = false;

document.addEventListener('DOMContentLoaded', () => {
    const userObject = getUserObject();
    if (userObject === null || userObject.IsAuthenticated === undefined || userObject.IsAuthenticated === null || userObject.IsAuthenticated === false) {
        return;
    }

    initSessionTimer();
});

function initLogout() {
    clearInterval(heartbeatInterval);
    logout();
}

function resetSessionTimer() {
    sessionStart = getCurrentTime();
}

function heartBeat() {
    let sessionElapsed = getCurrentTime() - sessionStart;    
    if (sessionElapsed > timeOut) {
        initLogout();
    } else if (gaveWarning === false && sessionElapsed > warnAfter) {
        let warningTimeLabel = document.querySelector<HTMLElement>('#warnTimeMinutes');
        gaveWarning = true
        sessionTimerModal?.showModal();
        if (warningTimeLabel !== null) {
            let warnMinutes = (warnAfter > 0) ? warnTime / 1000 / 60 : 0;
            warningTimeLabel.innerText = warnMinutes > 0 ? `${warnMinutes.toString()} minutes` : 'less than 1 minute';
        }
    }
}

function initHeartbeat() {
    if (heartbeatTimer === null) {
        resetSessionTimer();
        heartbeatTimer = setInterval(heartBeat, heartbeatInterval);
    }
}

export function initSessionTimer() {
    const usajConfig = getUsajConfig();
    timeOut = getUsajConfig().IdleTimeout || 1200000;
    warnAfter = timeOut - warnTime;
    sessionTimerModal = document.querySelector<HTMLDialogElement>('#sessionTimer-modal');
    initHeartbeat();
    if (sessionTimerModal === null) {
        console.debug('Cannot send timeout warning to user: Session timer modal is null.');
        gaveWarning = true;
    }
    else {
        document.querySelector<HTMLButtonElement>('#sessionTimer-logout')?.addEventListener('click', initLogout);
        document.querySelector<HTMLButtonElement>('#sessionTimer-keepalive')?.addEventListener('click', () => {
            gaveWarning = false;
            resetSessionTimer();
        });
    }
}
